import React from 'react'
import {Flex} from '/app/src/component'
import { connect } from 'react-redux'
import {UserSelector, SystemSelector}from '/app/src/model/selectors'
import SystemModel from '/app/src/model/System/model'
import MenuMainItem from '/app/src/component/Menu/MainItem'
import SVG from 'react-inlinesvg'
import style from './style.css'
import ClientChatMenu from './ClientChatMenu'
import ChatSettingsMenu from './ChatSettings'
import CompanySettingsMenu from './CompanySettings'
import MyProfileMenu from './MyProfile'

class MainMenuRightPanel extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            view: props.param[0],
        }
        this._renderMainMenu = this._renderMainMenu.bind(this)
        this._renderMainMenuItem = this._renderMainMenuItem.bind(this)

    }
    _renderMainMenuItem(svgSrc, svgfill, text, view){
        return (
            <Flex
                className={this.props.param[0]===view?style.MainMenuItemSelected:style.MainMenuItem}
                column shrink={0} onClick={()=>{
                    this.setState({view: view})
                }}>
                <Flex height='100%'>
                    <Flex hAlignContent='center' vAlignContent='center' basis='30%'>
                        <SVG cacheGetRequests={true} style={{fill: svgfill, height: '40px', width: '40px'}} src={svgSrc} />
                    </Flex>
                    <Flex grow hAlignContent='left' vAlignContent='center' overflowX='hidden'>
                        {text}
                    </Flex>
                </Flex>
            </Flex>
        )
    }
    _renderMainMenu(){
        return (
            <Flex column grow bg='#f7f7f7' w='100%' dataName='mainMenu'>
            <Flex column grow overflow='auto' bg='#f7f7f7'>
                    <MenuMainItem
                        svgSrc='/images/Menu_Overview_L.svg'
                        text='Översikt' to='/' exact
                        svgfill='#2ea2d2'
                        />
                    {this._renderMainMenuItem(
                        '/images/Menu_Profile.svg',
                        '#76b376',
                        'Min Profil',
                        'user')}

                    <MenuMainItem
                        svgSrc='/images/Menu_History.svg'
                        text='Historik' to='/history'
                        svgfill='#f6934b'
                        />

            {['manager', 'admin'].includes(this.props.role) &&
                <React.Fragment>

                    {this._renderMainMenuItem(
                        '/images/Menu_ClientChatOptions.svg',
                        '#f64b7f',
                        'Client Chat',
                        'clientChat'
                    )}


                    {this._renderMainMenuItem(
                        '/images/Menu_ChatOptions.svg',
                        '#a25cbf',
                        'Chattfunktioner',
                        'chatSettings'
                    )}

                </React.Fragment>
            }
            {['admin'].includes(this.props.role) &&

                    this._renderMainMenuItem(
                        '/images/Menu_CompanySettings.svg',
                        '#404040',
                        'Företagsinställningar',
                        'companySettings'
                    )
            }
            </Flex>
            </Flex>
        )
    }
    componentDidMount(){
        this.props.dispatch(SystemModel.menuToogle(true))

    }
    render(){
        switch(this.state.view){
            case 'companySettings':
                return <CompanySettingsMenu onClick={()=>{this.setState({view: 'main'})}}/>
            case 'user':
                return <MyProfileMenu onClick={()=>{this.setState({view: 'main'})}}/>
            case 'clientChat':
                return <ClientChatMenu onClick={()=>{this.setState({view: 'main'})}}/>
            case 'chatSettings':
                return <ChatSettingsMenu onClick={()=>{this.setState({view: 'main'})}}/>
            case 'main':
            default:
                return this._renderMainMenu()
        }
    }

}


export default connect(state => {return {
    param: SystemSelector.getParams(state),
    mainMenuToogle: SystemSelector.getMenuToogle(state),
    role: UserSelector.getRole(state)
}})(MainMenuRightPanel)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/MainMenu/index.js